import { render, staticRenderFns } from "./ShiftTabs.vue?vue&type=template&id=45092281&scoped=true&"
import script from "./ShiftTabs.vue?vue&type=script&lang=js&"
export * from "./ShiftTabs.vue?vue&type=script&lang=js&"
import style0 from "./ShiftTabs.vue?vue&type=style&index=0&id=45092281&scoped=true&lang=css&"
import style1 from "./ShiftTabs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45092281",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VFlex,VIcon,VRow,VTextField})
